import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCompass, FaFileAlt, FaHome, FaUsers, FaIdCard, FaHeartbeat, FaCreditCard, FaCar, FaSchool, FaDog, FaArrowRight } from 'react-icons/fa';
import './VivreEnEspagne.css';

const STEP_ICONS = [<FaCompass />, <FaFileAlt />, <FaHome />, <FaUsers />];
const ITEM_ICONS = [<FaIdCard />, <FaHeartbeat />, <FaCreditCard />, <FaCar />, <FaSchool />, <FaDog />];

const VivreEnEspagne = () => {
  const { t } = useTranslation();
  const etapes = t('vivrePage.steps.items', { returnObjects: true });
  const typesResidence = t('vivrePage.residenceTypes.items', { returnObjects: true });

  return (
    <div className="vivre-espagne-page">
      <section className="page-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 text-center">
              <img src="/images/logo.jpeg" alt={t('common.altLogo')} className="hero-logo" />
            </div>
            <div className="col-lg-9 text-center">
              <h1 className="page-title">{t('vivrePage.hero.title')}</h1>
              <p className="page-subtitle">{t('vivrePage.hero.subtitle')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="etapes-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5">{t('vivrePage.steps.title')}</h2>
          <div className="etapes-cards-row row g-4 justify-content-center">
            {etapes.map((etape, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-3">
                <div className="etape-card etape-card-animated">
                  <span className="etape-badge">{t('common.stepLabel', { n: index + 1 })}</span>
                  <div className="etape-number">{index + 1}</div>
                  <div className="etape-icon">{STEP_ICONS[index]}</div>
                  <h3 className="etape-title">{etape.title}</h3>
                  {etape.description && (
                    <p className="etape-description">{etape.description}</p>
                  )}
                  {etape.items?.length > 0 && (
                    <ul className="etape-list">
                      {etape.items.map((item, itemIndex) => (
                        <li key={itemIndex}>
                          <span className="item-icon">{ITEM_ICONS[itemIndex] || null}</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="residence-section py-5 bg-light">
        <div className="container">
          <h2 className="section-title text-center mb-5">{t('vivrePage.residenceTypes.title')}</h2>
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="arrow-flow-container">
                {typesResidence.map((type, index) => (
                  <React.Fragment key={index}>
                    <div className="arrow-flow-item">
                      <div className="arrow-flow-number">{index + 1}</div>
                      <h4 className="arrow-flow-title">{type.title}</h4>
                      <p className="arrow-flow-description">{type.description}</p>
                    </div>
                    {index < typesResidence.length - 1 && (
                      <div className="arrow-flow-connector">
                        <FaArrowRight className="arrow-icon" />
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className="col-lg-5">
              <div className="vivre-espagne-class-image-container">
                <img src="/images/classe1.png" alt="" className="vivre-espagne-class-image" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VivreEnEspagne;
